import { z } from 'zod';

export const HealthResponseSchema = z.object({
  status: z.literal('ok'),
});
export type HealthResponse = z.infer<typeof HealthResponseSchema>;

const ReadinessCheckSchema = z.object({
  status: z.enum(['ok', 'fail']),
  detail: z.string().optional(),
});

export const ReadinessResponseSchema = z.object({
  status: z.enum(['ready', 'not_ready']),
  version: z.string(),
  draining: z.boolean(),
  checks: z.object({
    database: ReadinessCheckSchema,
    storage: ReadinessCheckSchema,
    sandbox: ReadinessCheckSchema,
    model: ReadinessCheckSchema,
  }),
});
export type ReadinessResponse = z.infer<typeof ReadinessResponseSchema>;
